import { render, staticRenderFns } from "./customsdetails.vue?vue&type=template&id=7f4a9236&scoped=true&"
import script from "./customsdetails.vue?vue&type=script&lang=js&"
export * from "./customsdetails.vue?vue&type=script&lang=js&"
import style0 from "./customsdetails.vue?vue&type=style&index=0&id=7f4a9236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a9236",
  null
  
)

export default component.exports